module.exports = __webpack_public_path__ + "media/images/loader-040ed214890567953a6c3ccde1e2a859.gif";